import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';
import './MarketExpansion.css';

const MarketExpansion = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    { labelKey: 'nav.services', href: '/#services' },
    { labelKey: 'services.marketExpansion' }
  ];

  // 设置页面标题
  useEffect(() => {
    document.title = `${t('pages.marketExpansion.title')} - ${t('common.companyName')}`;
  }, [t]);

  return (
    <PageTemplate 
      titleKey="pages.marketExpansion.title"
      subtitleKey="pages.marketExpansion.subtitle"
      breadcrumbs={breadcrumbs}
    >
      {/* CTA 按钮 */}
      <div className="market-expansion-cta-top">
        <a href="/connect-us" className="cta-button-primary">
          {t('pages.marketExpansion.cta')}
        </a>
      </div>

      {/* 挑战与机遇 */}
      <div className="challenges-section">
        <h2>{t('pages.marketExpansion.challenges.title')}</h2>
        <div className="challenges-grid">
          {/* 左侧：挑战 */}
          <div className="challenges-column">
            <h3 className="challenges-title">{t('pages.marketExpansion.challenges.challengesTitle')}</h3>
            <div className="challenge-list">
              {[1, 2, 3, 4].map((num) => (
                <div key={num} className="challenge-item">
                  <h4>{t(`pages.marketExpansion.challenges.item${num}.title`)}</h4>
                  <p>{t(`pages.marketExpansion.challenges.item${num}.desc`)}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 右侧：机遇 */}
          <div className="opportunities-column">
            <h3 className="opportunities-title">{t('pages.marketExpansion.challenges.opportunitiesTitle')}</h3>
            <div className="opportunity-list">
              {[1, 2, 3].map((num) => (
                <div key={num} className="opportunity-item">
                  <h4>{t(`pages.marketExpansion.challenges.opportunity${num}.title`)}</h4>
                  <p>{t(`pages.marketExpansion.challenges.opportunity${num}.desc`)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 专业服务领域 */}
      <div className="services-section">
        <h2>{t('pages.marketExpansion.services.title')}</h2>
        <div className="services-list">
          {[1, 2, 3, 4].map((num) => (
            <div key={num} className="service-item">
              <h3>{t(`pages.marketExpansion.services.item${num}.title`)}</h3>
              <p>{t(`pages.marketExpansion.services.item${num}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 系统化拓展四步法 */}
      <div className="methodology-section">
        <h2>{t('pages.marketExpansion.methodology.title')}</h2>
        <div className="methodology-timeline">
          {[1, 2, 3, 4].map((num) => (
            <div key={num} className="methodology-step">
              <div className="step-content">
                <h3>{t(`pages.marketExpansion.methodology.step${num}.title`)}</h3>
                <p>{t(`pages.marketExpansion.methodology.step${num}.desc`)}</p>
              </div>
              {num < 4 && <div className="step-arrow">→</div>}
            </div>
          ))}
        </div>
      </div>

      {/* 为何我们能引领您的全球之旅 */}
      <div className="why-us-section">
        <h2>{t('pages.marketExpansion.whyUs.title')}</h2>
        
        {/* 统计数据 */}
        <div className="stats-grid-modern">
          <div className="stat-card">
            <div className="stat-number">
              {t('pages.marketExpansion.whyUs.stats.years.number')}
            </div>
            <div className="stat-label">
              {t('pages.marketExpansion.whyUs.stats.years.label')}
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-number">
              {t('pages.marketExpansion.whyUs.stats.projects.number')}
            </div>
            <div className="stat-label">
              {t('pages.marketExpansion.whyUs.stats.projects.label')}
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-number">
              {t('pages.marketExpansion.whyUs.stats.success.number')}
            </div>
            <div className="stat-label">
              {t('pages.marketExpansion.whyUs.stats.success.label')}
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-number">
              {t('pages.marketExpansion.whyUs.stats.countries.number')}
            </div>
            <div className="stat-label">
              {t('pages.marketExpansion.whyUs.stats.countries.label')}
            </div>
          </div>
        </div>

        {/* 独特优势 */}
        <div className="advantages-content">
          <h3>{t('pages.marketExpansion.whyUs.advantages.title')}</h3>
          <div className="advantages-grid">
            {[1, 2, 3].map((num) => (
              <div key={num} className="advantage-card">
                <h4>{t(`pages.marketExpansion.whyUs.advantages.item${num}.title`)}</h4>
                <p>{t(`pages.marketExpansion.whyUs.advantages.item${num}.desc`)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 最终行动号召 */}
      <div className="final-cta-section">
        <h2>{t('pages.marketExpansion.callToAction.title')}</h2>
        <p>{t('pages.marketExpansion.callToAction.description')}</p>
        <a href="/connect-us" className="cta-button-large">
          {t('pages.marketExpansion.callToAction.button')}
        </a>
      </div>
    </PageTemplate>
  );
};

export default MarketExpansion;
